import type {
	ResolutionOption,
	ResolutionOptionExternal,
} from '@atlassian/jira-issue-field-resolution/src/common/types.tsx';
import type { JiraResolutionFieldInput } from './types.tsx';

export const mapAllowedValuesToSelectOptions = (
	allowedValues: ResolutionOptionExternal[],
): ResolutionOption[] =>
	allowedValues.map(
		(value: ResolutionOptionExternal): ResolutionOption => ({
			value: value.id,
			label: value.name,
		}),
	);

export const transformDefaultResolutionValue = (
	value: ResolutionOptionExternal,
): ResolutionOption => ({
	value: value.id,
	label: value.name,
});

export const mutateResolutionField = (
	selectedResolution: ResolutionOption,
): JiraResolutionFieldInput => ({
	resolution: {
		resolutionId: selectedResolution.value,
	},
});
